
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.864"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.864",
    "ar-eg": "static-7.864",
    "bg": "static-7.864",
    "bn": "static-7.864",
    "ca-es": "static-7.864",
    "cs": "static-7.864",
    "da": "static-7.864",
    "de": "static-7.864",
    "el": "static-7.864",
    "en-gb": "static-7.864",
    "en": "static-7.864",
    "es-mx": "static-7.864",
    "es": "static-7.864",
    "fi": "static-7.864",
    "fr-ca": "static-7.864",
    "fr": "static-7.864",
    "he-il": "static-7.864",
    "hr": "static-7.864",
    "hu": "static-7.864",
    "id": "static-7.864",
    "it": "static-7.864",
    "ja": "static-7.864",
    "ko": "static-7.864",
    "lt": "static-7.864",
    "ms": "static-7.864",
    "nl": "static-7.864",
    "no": "static-7.864",
    "pl": "static-7.864",
    "pt-br": "static-7.864",
    "pt-pt": "static-7.864",
    "ro": "static-7.864",
    "ru": "static-7.864",
    "sk": "static-7.864",
    "sl": "static-7.864",
    "sv": "static-7.864",
    "th": "static-7.864",
    "tl": "static-7.864",
    "tr": "static-7.864",
    "uk": "static-7.864",
    "vi": "static-7.864",
    "x-pseudo": "static-7.864",
    "zh-cn": "static-7.864",
    "zh-hk": "static-7.864",
    "zh-tw": "static-7.864"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.864'}); }
})();


